import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { lambda } from '@/utils/postToLambda';

export type StatusDefinitions = Array<{
    status: string;
    isWorkstreamCompletion?: boolean;
    isStatusCompletion?: boolean;
    isPendingCustomer?: boolean;
}>;
export interface StatusDefinitionsReturn {
    organisationId: number;
    statusDefinitions: StatusDefinitions;
}

export const getStatusDefinitions = async () => {
    const results: StatusDefinitionsReturn = await fetchFromLambda(
        '/workactivity/assignment/status-definitions'
    );
    return results.statusDefinitions;
};

export const putStatusDefinitions = async (
    statusDefinitions: StatusDefinitions
) => {
    const results = await lambda.put(
        '/workactivity/assignment/status-definitions',
        JSON.stringify(statusDefinitions)
    );
    return results;
};
